module.exports = __webpack_public_path__ + "img/status-green.e748b3d9.svg";